import { Reveal, Divider, Overline } from "@/components/layout/Atoms";
import { useContent } from "@/contexts/ContentContext";
import { resolveMediaUrl } from "@/lib/api";

export default function APropos() {
    const c = useContent();
    const ap = c.apropos;

    return (
        <div data-testid="page-apropos" className="container-k py-16 md:py-24">
            <div className="max-w-3xl">
                <Overline>{ap.hero.overline}</Overline>
                <h1 className="mt-4 font-heading font-light text-5xl md:text-7xl leading-[1.0] text-kayama-ink">
                    {ap.hero.h1_part1} <span className="italic text-kayama-pink">{ap.hero.h1_italic}</span><br />{ap.hero.h1_part2}
                </h1>
            </div>

            <Divider />

            <div className="grid lg:grid-cols-12 gap-12 items-start mt-12">
                <Reveal className="lg:col-span-5">
                    <img src={resolveMediaUrl(ap.image)} alt="Plat signature" className="w-full h-[560px] object-cover" />
                    <p className="script text-4xl text-kayama-gold mt-6 text-center">{ap.script_under_image}</p>
                </Reveal>

                <div className="lg:col-span-7 space-y-8 text-kayama-brown-2 leading-relaxed text-lg">
                    {ap.paragraphs.map((p, i) => (
                        <Reveal delay={i * 120} key={i}>
                            <p className={i === 0 ? "first-letter:font-heading first-letter:text-7xl first-letter:font-light first-letter:text-kayama-pink first-letter:float-left first-letter:mr-3 first-letter:leading-[0.85]" : ""}>
                                {p}
                            </p>
                        </Reveal>
                    ))}

                    <Reveal delay={360}>
                        <div className="grid grid-cols-2 gap-6 pt-6 border-t border-kayama-line">
                            <div>
                                <Overline>{ap.promise_label}</Overline>
                                <p className="mt-3 font-heading text-2xl text-kayama-brown">{ap.promise_value}</p>
                            </div>
                            <div>
                                <Overline>{ap.signature_label}</Overline>
                                <p className="mt-3 font-heading text-2xl text-kayama-brown">{ap.signature_value}</p>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </div>

            <div className="mt-32 relative">
                <img src={resolveMediaUrl(ap.banner.image)} alt="Table dressée" className="w-full h-[420px] object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-kayama-brown/70 to-transparent flex items-end">
                    <div className="container-k py-12">
                        <p className="script text-5xl text-kayama-gold-light">{ap.banner.script}</p>
                        <p className="font-heading text-3xl md:text-4xl text-kayama-cream font-light max-w-xl mt-2">{ap.banner.text}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
